import {Pipe, PipeTransform} from '@angular/core';

/**
 * This pipe handles parsing an enumeration item.
 */
@Pipe({
  name: 'enumParse',
})
export class EnumParsePipe implements PipeTransform {

  /**
   * Transform an enumeration item to a string value.
   * @example
   * // returns 'Monday'
   * transform(DayOfWeek.MONDAY)
   * @example
   * // returns 'Key Holder'
   * transform(CapabilityType.KEY_HOLDER)
   * @param value an enumeration item.
   */
  transform(value: string) {
    if (!value) {
      return;
    }
    const splitStr = value.toLowerCase().split('_');
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }
}

/**
 * Transforms an enumeration item to a string value.
 * @param value an enumeration item.
 */
export function enumParse(value: string): string {
  return new EnumParsePipe().transform(value);
}
